var $f7ac89ad9c1c6708$exports = {};
$f7ac89ad9c1c6708$exports = {
    "Clear search": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{442}\u{44A}\u{440}\u{441}\u{435}\u{43D}\u{435}`
};


export {$f7ac89ad9c1c6708$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
